import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import financial from './financial/sagas';
import sales from './sales/sagas';

export default function* rootSaga() {
  return yield all([auth, financial, sales]);
}
